import { IconButton } from '@mui/material'
import { m } from 'framer-motion'
import { NavLink } from 'react-router-dom'

import { varTap, varHover, transitionTap } from 'src/components/shared/animate'
import FaIcon from '../../components/shared/faIcon/FaIcon'
import customConfig from 'customConfig'
import { TRANSACTIONS_URL } from '../../constants/navigation'

export function TransactionHistoryButton() {
  return (
    <NavLink to={TRANSACTIONS_URL}>
      <IconButton
        component={m.button}
        whileTap={varTap(0.96)}
        whileHover={varHover(1.04)}
        transition={transitionTap()}
        sx={{
          p: 0,
          width: 40,
          height: 40
        }}
      >
        <FaIcon icon={customConfig.transactionsIcon} size='xs' />
      </IconButton>
    </NavLink>
  )
}
